<gp-tabs
  [hasScroller]="hasScroller"
  [indicator]="indicator"
  [child]="child"
  (activeTabChange)="onActiveTabChange($any($event))"
>
  <gp-tab
    *ngFor="let tab of tabs; trackBy: trackByFn; let index = index"
    [child]="child"
    [label]="tab.label | translate"
    [active]="active ? tab.name === active : index === 0"
    [disabled]="tab.disabled"
  ></gp-tab>
</gp-tabs>
